import { useEffect } from "react";

import { useLocation } from "../useLocation/useLocation";
import { useNavigate } from "../useNavigate/useNavigate";

const ManualScrollRestoration = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const locationState = location.state;
  const toPath = location.pathname + location.search;

  useEffect(() => {
    const { scrollPosition, ...restLocationState } = locationState ?? {};

    if (scrollPosition) {
      if (typeof scrollPosition === "number" && scrollPosition > 0) {
        requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
      }

      navigate(toPath, {
        replace: true,
        state: restLocationState, // resets location state without the scroll position
      });
    }
  }, [locationState, navigate, toPath]);

  return null;
};

export { ManualScrollRestoration };
